import { render, staticRenderFns } from "./GroupMsg.vue?vue&type=template&id=25b8dd66&scoped=true"
import script from "./GroupMsg.vue?vue&type=script&lang=js"
export * from "./GroupMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b8dd66",
  null
  
)

export default component.exports